/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Korean
export default {
    'fabric.atlassianSwitcher.switchTo': '전환 대상',
    'fabric.atlassianSwitcher.switchToTooltip': '다음으로 전환…',
    'fabric.atlassianSwitcher.recent': '최근 항목',
    'fabric.atlassianSwitcher.more': '더 보기',
    'fabric.atlassianSwitcher.try': '시도',
    'fabric.atlassianSwitcher.manageList': '목록 관리',
    'fabric.atlassianSwitcher.jiraProject': 'Jira 프로젝트',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence 스페이스',
    'fabric.atlassianSwitcher.people': '사람들',
    'fabric.atlassianSwitcher.administration': '관리',
    'fabric.atlassianSwitcher.discoverMore': '자세히 살펴보기',
    'fabric.atlassianSwitcher.errorHeading': '문제가 발생했습니다.',
    'fabric.atlassianSwitcher.errorText': '이 오류를 추적하고 있습니다. 새로 고침을 해도 문제가 해결되지 않는 경우 언제든지 문의해 주시기 바랍니다.',
    'fabric.atlassianSwitcher.errorImageAltText': '고장 난 로봇과 여러 사람들이 이 문제를 해결하기 위해 노력하고 있습니다.',
    'fabric.atlassianSwitcher.expand': '확장',
};
//# sourceMappingURL=ko.js.map